import { AutogenModelUpcomingActivities, AutogenRowUpcomingActivities } from "./autogen/AutogenModelUpcomingActivities";

export class ModelUpcomingActivities extends AutogenModelUpcomingActivities<RowUpcomingActivities> {
	constructor() {
		super(RowUpcomingActivities);
	}
}

export class RowUpcomingActivities extends AutogenRowUpcomingActivities {
}